/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './ExpiredInsuranceContentTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface contentTileType {
  insuranceName: string;
  policyNumber: number;
  startDate: string;
  expireDate: string;
  onClick?: any;
  onEdit?: any;
  isEdit?: boolean;
}
const ExpiredInsuranceContentTile: React.FC<contentTileType> = ({
  startDate,
  insuranceName,
  policyNumber,
  expireDate,
  onClick,
  onEdit,
  isEdit = false,
}) => {
  const { t } = useTranslation();
  const trans = t;
  return (
    <Grid container className="expired_insurane_inner_box">
      <Grid item xs={9}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {insuranceName}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '10px',
            }}
          >
            {trans('Policy No')}:{' '}
            <span style={{ color: themes.blackDefault }} className="mx-1">
              {policyNumber}
            </span>{' '}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '2px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Start Date')}:{' '}
            <span style={{ color: themes.blackDefault }} className="mx-1">
              <DateField value={startDate} format={baseDateFormatting} />
            </span>{' '}
            |
            <span style={{ color: themes.defaultError }} className="mx-1">
              {' '}
              {trans('Expiry Date')}:{' '}
              <DateField value={expireDate} format={baseDateFormatting} />
            </span>{' '}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={1}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        {isEdit && (
          <Box className="icon-box_leave_history" onClick={onEdit}>
            {' '}
            <i className="las la-pencil-alt" />{' '}
          </Box>
        )}
      </Grid>

      <Grid
        item
        xs={1}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Box className="icon-box_leave_history" onClick={onClick}>
          {' '}
          <i className="las la-eye" />{' '}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ExpiredInsuranceContentTile;
